// API_BASE_URL is a CRA build-time variable (REACT_APP_ prefix required for
// Create React App to expose it) - baked into the compiled JS bundle at
// "npm run build" time, same mechanism as iai_itrs's VITE_BACKEND_URL.
// Falls back to the local dev backend if unset, matching this file's
// previous hardcoded default.
const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:9000/api",
};

export default config;
